import './relative-date-select.scss';
import { RelativeDateSelect } from '@/common/setter/default-value-setter/components/relative-date-select';
import { RelativeRangeSelect } from '@/common/setter/default-value-setter/components/relative-range-select';
export function RelativeSelect(props) {
    const { componentName } = props;
    if (componentName === 'CnDatePickerPro') {
        return React.createElement(RelativeDateSelect, { ...props });
    }
    else if (componentName === 'CnDateRangePickerPro') {
        return React.createElement(RelativeRangeSelect, { ...props });
    }
    return null;
}
